<template>
	<el-select v-model="nicheng" :placeholder="ming?ming:'请输入店铺名称/昵称/手机'" filterable remote clearable :remote-method="Fujilie" :loading="loading"
	 value-key="id" @change="Xuanzeshangji" style="width: 100%;">
		<el-option v-for="l in lie" :label="l.ming" :value="l" />
	</el-select>
</template>

<script>
	var that;
	export default {
		data() {
			return {
				nicheng: '',
				lie: [],
				loading: false
			};
		},
		props: {
			id: {
				type: [String],
			},
			ming: {
				type: String,
			},

		},
		created() {
			that = this;
			that.nicheng = that.ming;
			
		},
		methods: {
			Fujilie(guanjianci) {
				that.loading = true;
				this.$post('k=shanghu', {
					ye: 1,
					jitiao: 10,
					guanjianci: guanjianci
				}, function(s) {
					if (s.shi == 1) {
						setTimeout(function() {
							that.loading = false;
							that.lie = s.shu.lie;
						}, 500)
					} else {
						that.lie = [];
					}
				});
			},
			Xuanzeshangji(e) {
				this.$emit('update:id', e.id || '');
				this.$emit('update:ming', e.ming || '');
			}
		}
	}
</script>

<style>


</style>
